/* @flow */
import type { Action } from "../action";

export type StockPoint = {
  stock: string,
  value: number,
  date: number
};

export type State = { [key: string]: Array<StockPoint> };

function pushStockPoint(state: State, point: StockPoint) {
  const currentPoints = state[point.stock] || [];
  const nextPoints = currentPoints.slice(-4 * 60 * 60);

  if (currentPoints.length > 0) {
    if (currentPoints[currentPoints.length - 1].date >= point.date) {
      // Пропускаем точки в той же дате и точки,
      // не соотыветствующие порядку сортировки.
      return state;
    }
  }

  nextPoints.push(point);

  return {
    ...state,
    [point.stock]: nextPoints
  };
}

function receiveSocketMessage(state, payload) {
  switch (payload.op) {
    case "stockPush":
      return pushStockPoint(state, {
        stock: payload.stock,
        date: payload.serverTime * 1000,
        value: parseFloat(payload.value)
      });
    default:
      return state;
  }
}

type StockHistoryPayload = {
  stock: string,
  history: {
    [date: string]: string
  }
};

function receiveStockHistory(
  state: State,
  payload?: StockHistoryPayload
): State {
  if (typeof payload !== "object") {
    throw new TypeError("Unexpected stock history payload");
  }

  const { stock, history } = payload;

  const pointsByDate = new Map();

  if (state[stock]) {
    state[stock].forEach(point => {
      pointsByDate.set(point.date, point);
    });
  }

  const dates = Object.keys(history);

  dates.forEach(date => {
    // HACK: Чиним формат дат чтобы они корректно парсились в сафари
    const correctDate = new Date(`${date.replace(" ", "T")}+00:00`).valueOf();

    pointsByDate.set(correctDate, {
      stock,
      date: correctDate,
      value: Number(history[date])
    });
  });

  const nextPoints = [...pointsByDate.values()].sort((a, b) => a.date - b.date);

  return {
    ...state,
    [stock]: nextPoints
  };
}

function stocks(state: State = {}, action: Action): State {
  switch (action.type) {
    case "RECEIVE_STOCK_HISTORY":
      return receiveStockHistory(state, action.payload);
    case "RECEIVE_SOCKET_MESSAGE":
      return receiveSocketMessage(state, action.payload);
    default:
      return state;
  }
}

export default stocks;

export function getServerTime(activeStock: string, state: State) {
  const points = state[activeStock];

  if (Array.isArray(points) && points.length > 0) {
    const lastPoint = points[points.length - 1];
    return lastPoint.date;
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/redux/reducer/points.js